import React from 'react';
import Logo from '../../../images/logo/logoGif.gif';

export const GifLogo: React.FC = () => {
    const [rand, setRand] = React.useState(Math.random());

    React.useEffect(() => {
        setRand(Math.random());
    }, []);

    return (
        <img
            width={152}
            height={235}
            alt="Workflow"
            src={`${Logo}?${rand}`}
            className="mx-auto temporary-logo w-auto"
        />
    )
}